import React, { useRef, useState } from "react";
import LabelledButton from "../buttons/LabelledButton";
import SubmitButton from "../buttons/SubmitButton";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import { exportToCSV, exportToExcel } from "../../../utils/tableExports";
// import TableContent from "./TableContent";
import { MultiSelect } from "react-multi-select-component";
import { PrintReport } from "../PrintReport";
import { useSelector } from "react-redux";
// import { ApiHook } from "../../../hooks/apiHook";
// import { toast } from "react-toastify";

const PayoutTableFilter = ({
  setActiveTab,
  activeTab,
  headers,
  reportHeader,
  data,
  type,
  setCurrentPage
}) => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
);
  const options = [
    { value: "paid", label: `${t("paid")}` },
    { value: "requested", label: `${t("requested")}` },
    { value: "approved", label: `${t("approved")}` },
    { value: "rejected", label: `${t("rejected")}` },
  ];

  // Initialize selectedValue to "paid" when the component is mounted
  const [selectedValue, setSelectedValue] = useState(activeTab);
  const currencySymbol = useSelector((state) => state.user.selectedCurrency.symbolLeft);

  const handleTabChange = (e) => {
    if (e.target.id === "searchButton") {
      setCurrentPage(1);
      if (selectedValue.length === 0) {
        setActiveTab([]);
      } else {
        setActiveTab(selectedValue);
      }
    } else if (e.target.id === "resetButton") {
      setActiveTab([
        { value: "paid", label: `${t("paid")}` },
        { value: "requested", label: `${t("requested")}` },
        { value: "approved", label: `${t("approved")}` },
        { value: "rejected", label: `${t("rejected")}` },
      ]);
      setSelectedValue([
        { value: "paid", label: `${t("paid")}` },
        { value: "requested", label: `${t("requested")}` },
        { value: "approved", label: `${t("approved")}` },
        { value: "rejected", label: `${t("rejected")}` },
      ]);
    }
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedValue(selectedOptions);
  };

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  // Function to translate specific fields
  const addLangToValues = (obj) => {
    const newObj = {};
    for (const [key, value] of Object.entries(obj)) {
      if (key === "paymentMethod" || key === "status") {
        newObj[key] = t(value); // Translate the value using the i18n translation function
      } else {
        newObj[key] = value;
      }
    }
    return newObj;
  };

  const reportData = data?.map(item => {
    if (item.paymentMethod || item.status) {
      const translatedItem = addLangToValues(item);
      return translatedItem;
    }
    return item; // Return unmodified item if paymentMethod and status are not present
  });

  // const createReportMutation = ApiHook.CallCreateReport();
  // const downloadReport = (reportType, fileType) => {
  //   const data = {
  //     reportType:reportType,
  //     fileType: fileType
  //   };
  //   createReportMutation.mutateAsync(data, {
  //     onSuccess: (res) => {
  //       if (res.data.status) {
  //         toast.success(t(res.data.data));
  //       }
  //     }
  //   })
  // }

  return (
    <>
      <div className="filter_Section">
        <div className="row justify-content-between">
          <div className="col-md-3 payout-filter">
            <div className="right_search_div d-flex gap-1">
              <MultiSelect
                id="payoutFilter"
                options={options}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  color: "#f15623", // Text color
                  borderColor: "#f15623", // Border color
                }}  
                className="form-control"
                overrideStrings={{
                  allItemsAreSelected: `${t("All_items_are_selected")}`,
                  selectAll: `${t("select_all")}`,
                  selectSomeItems: `${t("select")}`,
                  search: `${t("search")}`,
                }}
              />
              <SubmitButton
                isSubmitting=""
                text="search"
                className="btn btn-primary"
                click={handleTabChange}
                id="searchButton"
              />
              <SubmitButton
                isSubmitting=""
                text="reset"
                className="btn btn-secondary"
                click={handleTabChange}
                id="resetButton"
              />
            </div>
          </div>
          <div className="col-md-4 text-end mob_filter_right">
            <LabelledButton
              className="fa fa-file-excel"
              text=" Excel"
              click={() => exportToExcel(reportData, reportHeader, type, currencySymbol, conversionFactor)}
              // click={() => downloadReport("payout", "xlsx")}
            />
            <LabelledButton
              className="fa fa-file-text"
              text=" CSV"
              click={() => exportToCSV(reportData, reportHeader, type, currencySymbol, conversionFactor)}
              // click={() => downloadReport("payout", "csv")}
            />
            <LabelledButton
              className="fa fa-print"
              text=" Print"
              click={handlePrint}
            />
          </div>
          <div style={{ display: "none", padding: "30px" }}>
            <PrintReport
              ref={tableRef}
              data={data}
              headers={headers}
              type={"payout"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PayoutTableFilter;
